var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _circle5, _mask, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeQuote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 94,
    viewBox: "0 0 95 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.0704,
    cy: 37.7218,
    r: 37.3468,
    fill: "#FFE4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0703 22.2749H49.6896H91.2619C92.3665 22.2749 93.2619 23.1703 93.2619 24.2749V89.8749C93.2619 90.9794 92.3665 91.8749 91.2619 91.8749H40.0703C38.9657 91.8749 38.0703 90.9794 38.0703 89.8749V24.2749C38.0703 23.1703 38.9657 22.2749 40.0703 22.2749Z",
    fill: "white",
    stroke: "#BA0000",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9111 42.1602H80.3076",
    stroke: "#BA0000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9111 53.5605H80.3076",
    stroke: "#BA0000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9111 64.3604H80.3076",
    stroke: "#BA0000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9111 76.9609H80.3076",
    stroke: "#BA0000",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9133,
    cy: 42.1604,
    r: 1.8,
    fill: "#BA0000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9133,
    cy: 53.5607,
    r: 1.8,
    fill: "#BA0000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9133,
    cy: 64.3605,
    r: 1.8,
    fill: "#BA0000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9133,
    cy: 76.9606,
    r: 1.8,
    fill: "#BA0000"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.1133,
    y: 16.875,
    width: 28.7956,
    height: 11.4,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.1133,
    y: 16.875,
    width: 28.7956,
    height: 11.4,
    rx: 1,
    fill: "white",
    stroke: "#BA0000",
    strokeWidth: 6,
    mask: "url(#path-11-inside-1)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeQuote);
export default __webpack_public_path__ + "static/media/free-quote.c9642b831328bfa3db3da1236f0253fb.svg";
export { ForwardRef as ReactComponent };